import React, { Fragment } from "react";
import FileUploadDialog from "../FileUploadDialog";

import withTitle from "../withTitle";

import "../../obflow.css";

interface IToolObFlowsheetViewState {
    isLoading: boolean | string;
    isUploadDialogOpen: boolean;
    sheetData: any;
}

class ToolObFlowsheetView extends React.Component<{}, IToolObFlowsheetViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const state: IToolObFlowsheetViewState = {
            isLoading: false,
            isUploadDialogOpen: false,
            sheetData: {}
        };

        this.state = state;

        this.toggleUploadDialog = this.toggleUploadDialog.bind(this);
        this.uploadSuccess = this.uploadSuccess.bind(this);
    }

    public render() {
        return (
            <div className="viewer-root obflow-root">
                <FileUploadDialog
                    isOpen={this.state.isUploadDialogOpen}
                    accept=".csv"
                    showProgress={true} descriptionOverride="-"
                    closeOnSuccess={true}
                    title="Upload Flowsheet"
                    onRequestClose={this.toggleUploadDialog} onUploadSuccess={this.uploadSuccess}
                    endpoint="tools/ob-flowsheet/upload">
                </FileUploadDialog>
                <p className="print-hide">
                    To convert a flowsheet for printing, upload the file exported from Prime Suite.<br />
                    The result will contain up to the last 12 months of information from the flowsheet.
                </p>
                {this.state.isLoading === true
                    ? <div className="spinner lds-dual-ring" />
                    : typeof this.state.isLoading === "string"
                        ? <div className="error-text">{this.state.isLoading}</div>
                        : null}
                <div className="action-panel-dialog print-hide" style={{ marginBottom: "1em" }}>
                    <button type="button" className="button text-with-icon" onClick={this.toggleUploadDialog}><i className="icon-upload" /><span>Upload</span></button>
                    {this.state.sheetData.name ? <button type="button" className="button text-with-icon" onClick={() => window.print()}><i className="icon-print" /><span>Print</span></button> : null}
                </div>
                {!!this.state.sheetData.name
                    ? <div>
                        {this.renderTable(this.state.sheetData)}
                    </div>
                    : null}
            </div>
        );
    }

    private renderTable(sheet: any) {
        return <>
            <div className="print-hide">Below is a sample of the data to be printed:<br /><br /></div>
            <table className="obflow">
                <thead>
                    <tr className="header">
                        <td colSpan={10}>
                            <h1>{sheet.name} &mdash; OB Lab Flowsheet</h1>
                            <div>Patient ID: {sheet.patientId}</div>
                        </td>
                    </tr>
                    <tr>
                        <th>Test</th>
                        <th>Unit</th>
                        <th>Date</th>
                        <th>Result</th>
                    </tr>
                </thead>
                <tfoot>
                    <tr>
                        <td colSpan={10}></td>
                    </tr>
                </tfoot>
                <tbody>
                    {sheet.tests.map((test: any, testIndex: number) => <Fragment key={test.name}>
                        {(test.results.length ? test.results : [{}]).map((a: any, i: number) => <tr className={(testIndex % 2 === 1 ? "bg" : "") + (i > 0 ? " obflow-row-ext" : "")} key={i}>
                            <td>{i === 0 ? test.name : null}</td>
                            <td>{i === 0 ? test.unit : null}</td>
                            <td>{a.date || "\u2014\u2014"}</td>
                            <td>{a.value}</td>
                        </tr>)}
                    </Fragment>)}
                </tbody>
            </table>
        </>;
    }

    private toggleUploadDialog() {
        const isUploadDialogOpen = this.state.isUploadDialogOpen;
        this.setState({
            isUploadDialogOpen: !isUploadDialogOpen
        });
    }

    private uploadSuccess(ids: string[], results?: any[]) {
        if (!results) {
            this.setState({
                isLoading: "The server response contained no data"
            });
            return;
        }

        const result = results[0];

        this.setState({
            sheetData: result
        });
    }
}

export default withTitle("OB Flowsheet Converter", ToolObFlowsheetView);
